import React from 'react';
import _ from 'lodash';
import Button from 'components/Button';
import COLORS from 'shared/constants/colors';
import {
  Container,
  Wrapper,
  RegisterSection,
} from 'styles/pages/home/register-banner';

const RegisterBanner = ({ toggleSignUpDialog }) => (
  <Container>
    <Wrapper>
      <RegisterSection>
        <h2>Getting Started has Benefits</h2>
        <p>
          Register an account to scale my ecommerce business with the industry’s
          fastest order-to-ship response time.
        </p>
        <Button
          containerStyle={{
            backgroundColor: COLORS.BLACK,
            fontSize: '16px',
            borderRadius: '50px',
            padding: '12px',
            lineHeight: '1.5',
            color: COLORS.WHITE,
            height: '40px',
            alignSelf: 'center',
            fontWeight: '700',
          }}
          variant='text'
          title='REGISTER'
          onClick={() =>
            _.isFunction(toggleSignUpDialog) && toggleSignUpDialog()
          }
        />
      </RegisterSection>
    </Wrapper>
  </Container>
);

export default RegisterBanner;
